import throttle from 'lodash/throttle';

export default class Header {
  constructor(el) {
    this.DOM = { el: el };
    this.DOM.hero = document.querySelector('.hero');

    this.state = {
      heroHeight: this.DOM.hero.offsetHeight
    };

    this.onScroll = this.onScroll.bind(this);

    this.onScroll();
    this.bindEvents();
  }

  bindEvents() {
    window.addEventListener('scroll', throttle(this.onScroll, 50));
  }

  onScroll() {
    this.DOM.el.classList.toggle('header--black', window.scrollY >= this.state.heroHeight);
  }
}